import {createFileRoute, useParams} from '@tanstack/react-router';
import {Card3dsPasswordPage} from 'pages/accounts/credits/card';

const Card3dsPasswordRoute = () => {
  const {cardId} = useParams({
    from: '/_protected/home/accounts/cards/$cardId_/3ds-password',
  });
  return <Card3dsPasswordPage cardId={cardId} />;
};

export const Route = createFileRoute(
  '/_protected/home/accounts/cards/$cardId_/3ds-password',
)({
  component: Card3dsPasswordRoute,
  staticData: {crumbKey: 'navigation.card'},
});
